const GoogleAdTextAndSquareBanner = () => {
  return (
    <>
      <hr />
      <a href="https://www.jdoqocy.com/click-101154220-15255255" target="_top">Sign up today to receive $350 in free credits and free usage of 20+ products on Google Cloud.</a><img src="https://www.tqlkg.com/image-101154220-15255255" width="1" height="1" border="0" />

      <a href="https://www.jdoqocy.com/click-101154220-15552639" target="_top">
        <img src="https://www.ftjcfx.com/image-101154220-15552639" width="300" height="250" alt="" border="0" /></a>
    </>
  );
};

export default GoogleAdTextAndSquareBanner;
